import { getRequest } from "../RestServices";
import * as urls from "../../api/updateActiveUnits/url";
export const getProfilesForVodafone = async () => {
  try {
    return await getRequest(urls.GET_VODAFONE_PROFILES);
  } catch (err) {
    return err;
  }
};
